import { render, staticRenderFns } from "./TermsIndex.vue?vue&type=template&id=049cee60&scoped=true&"
import script from "./TermsIndex.vue?vue&type=script&lang=js&"
export * from "./TermsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049cee60",
  null
  
)

export default component.exports